/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { useEffect } from "react";
import { setProfile } from "api/DxAPI";

const Personalisation = ({ fontSize, lineHeight, letterSpacing, fontSizeUnit, letterSpacingUnit }) => {
  useEffect(() => {
    const fontSizePercent = `${fontSize}${fontSizeUnit}`;
    const letterSpacingPixel = `${letterSpacing}${letterSpacingUnit}`;
    setProfile({ "font-size": fontSizePercent, "line-height": lineHeight, "letter-spacing": letterSpacingPixel });
  }, [fontSize, lineHeight, letterSpacing]);

  return null;
};

export default Personalisation;
